// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__148-q","colMin":"styles_colMin__1wPq6"};